import VueRouter from 'vue-router'

import Auth from './service/auth'
import Login from './pages/Login'
import Landing from './pages/Landing'

const options = {
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login,
    },
    {
      path: '/landing',
      name: 'landing',
      component: Landing,
    },
  ],
}

const router = new VueRouter(options)

router.beforeEach((to, from, next) => {
  if (to.name === 'login') {
    next()
    return
  }

  if (!Auth.check()) {
    next({ name: 'login' })
    return
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router.js